import {Envs} from './envs';
import {getConfig} from './getConfig';

const {envName} = getConfig();

export const isEnv = (env: Envs) => envName === env;
